import React from 'react';
import { Monitor, Star, Facebook } from 'lucide-react';

const AddOnsSection = () => {
  const addOns = [
    {
      id: 'website',
      title: 'Website',
      icon: <Monitor className="w-8 h-8 text-gray-600" />,
      services: [
        { name: 'Ads Landing Page', price: '$500' },
        { name: '3 Pages', price: '$900' },
        { name: '5 Pages', price: '$1,500' },
        { name: '10 Pages', price: '$3,000' },
        { name: 'Host a Site', price: '$50/month' },
        { name: 'SEO Optimized', price: '$100/hour' }
      ]
    },
    {
      id: 'adwords',
      title: 'AdWords',
      icon: (
        <div className="w-8 h-8 flex items-center justify-center">
          <div className="w-6 h-6 bg-gradient-to-r from-blue-500 via-green-500 to-yellow-500 rounded-sm flex items-center justify-center">
            <span className="text-white text-xs font-bold">G</span>
          </div>
        </div>
      ),
      services: [
        { name: 'Budget up to $999', price: '($250 Management Fee)' },
        { name: 'Budget $1,000 - $2,499', price: '($500 Management Fee)' },
        { name: 'Budget $2,500 - $4,999', price: '($750 Management Fee)' },
        { name: 'Budget $5,000 - $9,999', price: '($1,000 Management Fee)' },
        { name: 'Budget $10,000+', price: '(15% Management Fee)' }
      ]
    },
    {
      id: 'social-blogs',
      title: 'Social / Blogs',
      icon: (
        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
          <Facebook className="w-5 h-5 text-white" />
        </div>
      ),
      services: [
        { name: '4 Posts', price: '$400' },
        { name: '8 Posts', price: '$800' },
        { name: '12 Posts', price: '$1,000' },
        { name: '1 Video', price: '$150' },
        { name: '2 Videos', price: '$250' },
        { name: 'Press Release', price: '$250' }
      ]
    },
    {
      id: 'rev-gen',
      title: 'Rev Gen',
      icon: (
        <div className="w-8 h-8 flex items-center justify-center">
          <div className="grid grid-cols-2 gap-1">
            <Star className="w-3 h-3 text-yellow-500 fill-current" />
            <Star className="w-3 h-3 text-yellow-500 fill-current" />
            <Star className="w-3 h-3 text-yellow-500 fill-current" />
            <Star className="w-3 h-3 text-yellow-500 fill-current" />
          </div>
        </div>
      ),
      services: [
        { name: '$99/month', price: '' },
        { 
          name: 'Streamlines customer feedback collection via email or SMS, simplifying review monitoring, responses and online showcasing for businesses.', 
          price: '' 
        }
      ]
    }
  ];

  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Título */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-2">
            Add-ons
          </h2>
          
        </div>

        {/* Grid de tarjetas */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {addOns.map((addOn) => (
            <div
              key={addOn.id}
              className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-6 hover:shadow-lg transition-shadow"
            >
              {/* Icono */}
              <div className="flex justify-center mb-4">
                {addOn.icon}
              </div>

              {/* Título */}
              <h3 className="text-xl font-bold text-gray-800 text-center mb-4">
                {addOn.title}
              </h3>

              {/* Línea divisoria punteada */}
              <div className="border-t border-dashed border-gray-400 mb-6"></div>

              {/* Lista de servicios */}
              <div className="space-y-3">
                {addOn.services.map((service, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="w-5 h-5 bg-blue-600 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <span className="text-gray-700 text-sm">{service.name}</span>
                      {service.price && (
                        <span className="text-gray-600 text-sm ml-2">{service.price}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AddOnsSection;





